import { render, staticRenderFns } from "./AdminPageDictionaries.vue?vue&type=template&id=30973724"
import script from "./AdminPageDictionaries.vue?vue&type=script&lang=js"
export * from "./AdminPageDictionaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports